import { AccessRoleCategory, resolveAccessRoleCategory } from 'domains/user'

export interface DepartmentEditPolicy {
  /** Whether the acting user can edit the target user's Access Departments. */
  canEdit: boolean
  /** Whether more than one department can be selected for the target user. */
  allowMultiple: boolean
}

/**
 * Resolves who can edit a user's Access Departments and whether multiple
 * departments can be selected. Mirrors the backend validateUpdateAdminDepartments rules:
 *
 * - Super Admin can update any user; non-Admin targets are limited to a single department.
 * - Admin can only update non-Admin targets, and only a single department.
 * - Non-Admin users cannot update anyone's Access Departments (read-only).
 */
export const resolveDepartmentEditPolicy = (
  actorAccessRoles: string | null | undefined,
  targetAccessRoles: string | null | undefined,
): DepartmentEditPolicy => {
  const actorCategory = resolveAccessRoleCategory(actorAccessRoles)
  const targetCategory = resolveAccessRoleCategory(targetAccessRoles)

  switch (actorCategory) {
    case AccessRoleCategory.SUPER_ADMIN:
      return {
        canEdit: true,
        allowMultiple: targetCategory !== AccessRoleCategory.NON_ADMIN,
      }
    case AccessRoleCategory.ADMIN:
      return {
        canEdit: targetCategory === AccessRoleCategory.NON_ADMIN,
        allowMultiple: false,
      }
    default:
      return { canEdit: false, allowMultiple: false }
  }
}
